exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".giveCredits{cursor:pointer}.giveCredits:hover{text-decoration:underline}", "", {"version":3,"sources":["/codebuild/output/src1799655552/src/src/components/Profile/GiveCredits.css"],"names":[],"mappings":"AAAA,aACE,cAAgB,CACjB,AAED,mBACE,yBAA2B,CAC5B","file":"GiveCredits.css","sourcesContent":[".giveCredits {\n  cursor: pointer;\n}\n\n.giveCredits:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Profile/GiveCredits.css
// module id = 2078
// module chunks = 0